import { render } from "./teamReports.vue?vue&type=template&id=6517d0c0"
import script from "./teamReports.vue?vue&type=script&lang=js"
export * from "./teamReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__